import React, { useState, useEffect, useCallback } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import {
  Box,
  Button,
  Checkbox,
  Collapse,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ImageUploading from "react-images-uploading";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { stateOptions } from "../../util/formElements";
import { listingStates, propertyTypes } from "../../util/flStates";
import { useAuth } from "../../contexts/AuthContext";
import { useUtil } from "../../contexts/UtilContext";
import axios from "axios";
import styles from "./ProAddListing.module.css";
import { Link, useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  normalizeUnit,
  generateAddressSignature,
} from "../../util/utilFunctions";

const ProAddListing = () => {
  const { accessToken } = useAuth();
  const navigate = useNavigate();

  // Google Maps libraries to load
  const libraries = ["places"];

  const { showLoader, hideLoader } = useUtil();
  const [isOldUser, setIsOldUser] = useState(false);

  const [userData, setUserData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    screenName: "",
    // photo: null,
    email: "",
    phoneNumber: "",
    password: null,
    confirmPassword: null,
    dateOfBirth: null,
    gender: "",
    country: "",
    // bio: "",
  });

  const [propertyData, setPropertyData] = useState({
    propertyType: "",
    bedrooms: "",
    bathrooms: "",
    areaSqft: "",
    streetAddress1: "",
    streetAddress2: "",
    landmark: "",
    city: "",
    state: "",
    zipcode: "",
    yearBuilt: "",
    images: null,
    heatingCooling: "",
  });

  const [listingData, setListingData] = useState({
    houseVisitsFrom: dayjs(),
    availableFrom: dayjs(),
    title: "",
    description: "",
    hideAddress: false,
    sellPrice: "",
    rentPrice: "",
    hoaPrice: "",
    listingType: null,
    sellHOAFreq: "",
    rentPetPolicy: "",
    rentLeaseLength: "",
    isRentProperty: false,
    isSellProperty: false,
  });

  const [showThankYou, setShowThankYou] = useState(false);
  const [createdListingType, setCreatedListingType] = useState(null);
  const [createdListingUrl, setCreatedListingUrl] = useState("");
  const [createdListingId, setCreatedListingId] = useState(null);
  const [duplicateListingInfo, setDuplicateListingInfo] = useState({
    show: false,
    propertyId: null,
    message: "",
    listingData: null,
  });

  const [propImages, setPropImages] = useState([]);
  const maxNumber = 12;

  const [expanded, setExpanded] = useState({
    ownerDetails: true,
    propertyDetails: true,
    listingDetails: false,
  });

  const [pageState, setPageState] = useState({
    propertyDetails: false,
    listingDetails: false,
  });
  const [agencies, setAgencies] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState(-1);

  const getSpecialString = (listingType) => {
    switch (listingType) {
      case listingStates.rent:
        return "Rent-Homes";
      case listingStates.sell:
        return "Buy-Homes";
      default:
        return "listings";
    }
  };

  const dropDownIconStyleOwnerDetails = {
    transform: expanded.ownerDetails ? "rotate(180deg)" : "",
    transition: "transform 150ms ease", // smooth transition
  };

  const dropDownIconStylePropertyDetails = {
    transform: expanded.propertyDetails ? "rotate(180deg)" : "",
    transition: "transform 150ms ease",
  };

  const dropDownIconStyleListingDetails = {
    transform: expanded.listingDetails ? "rotate(180deg)" : "",
    transition: "transform 150ms ease",
  };

  const handleUpgrade = async () => {
    // console.log('Upgrade it', createdListingId)
    navigate("/Landlord/Payment", {
      state: { listingId: createdListingId || null },
    });
  };

  useEffect(() => {
    if (accessToken) {
      (async () => {
        try {
          const requestData = {};

          const response = await axios.post(
            `${import.meta.env.VITE_BACKEND_URL}/user/details`,
            requestData,
            {
              headers: {
                Authorization: accessToken,
              },
            }
          );

          // console.log("response: ", response);

          if (response.status === 200) {
            if (
              response.data &&
              "success" in response.data &&
              response.data.success
            ) {
              // Fetching user successful
              // console.log("Signin successful");
              // console.log("response: ", response);
              // console.log("test: ", response.data.user);

              var userLiveData = response.data.user;

              setUserData((prev) => ({
                ...prev,
                firstName: userLiveData.first_name,
                middleName: userLiveData.middle_name,
                lastName: userLiveData.last_name,
                screenName: userLiveData.screen_name,
                email: userLiveData.email,
                phoneNumber: userLiveData.phone_number,
                dateOfBirth: dayjs(userLiveData.date_of_birth.slice(0, 10)),
                gender: userLiveData.gender,
                // bio: userLiveData.bio,
              }));

              setIsOldUser(true);
            } else {
              // Handle authentication error (e.g., display an error message)
              var errorMsg =
                response.data && response.data.message
                  ? response.data.message
                  : "Some error occurred while fetching your details. Please try again!";
              showErrorMessage(errorMsg);
              var responseError =
                response.data && response.data.error
                  ? response.data.error
                  : response.status + " error";
              // console.log(responseError);
            }
          } else {
            // Handle authentication error (e.g., display an error message)
            var errorMsg =
              response.data && response.data.message
                ? response.data.message
                : "Some error occurred while fetching your details. Please try again!";
            showErrorMessage(errorMsg);
            var responseError =
              response.data && response.data.error
                ? response.data.error
                : response.status + " error";
            // console.log(responseError);
            // You can display an error message to the user.
          }
        } catch (error) {
          console.error("Error during validation:", error);
        }
      })();
    }

    // setIsLoading(false);

    return () => {};
  }, [accessToken]);

  useEffect(() => {
    const fetchAgencies = async (accessToken) => {
      try {
        showLoader();
        const response = await axios.get(
          `${import.meta.env.VITE_BACKEND_URL}/dash/pro-agencies/list`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (response.status === 200 && response.data && response.data.success) {
          setAgencies(response.data.agencies || []);
        }
      } catch (error) {
        // console.log(error);
      } finally {
        hideLoader();
      }
    };

    if (accessToken) {
      fetchAgencies(accessToken);
    }
  }, [accessToken]);

  const handlePropertyDataChange = (event) => {
    const { name, value } = event.target;
    setPropertyData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setPageState((prev) => ({
      ...prev,
      propertyDetails: false,
    }));
  };

  const isLoaded = true;
  const loadError = false;
  // const  isLoaded, loadError } = useLoadScript({
  //     googleMapsApiKey: import.meta.env.VITE_GOOGLE_PLACES_API_KEY,
  //     libraries,
  //     version: "weekly", // Use stable weekly version
  //   });

  // Reference for the autocomplete input
  const [autocompleteRef, setAutocompleteRef] = useState(null);
  const [placesLoaded, setPlacesLoaded] = useState(false);

  const handlePlaceSelect = useCallback((place) => {
    try {
      if (!place || !place.geometry) {
        showErrorMessage("Please select a valid address from the dropdown");
        return;
      }

      let streetNumber = "";
      let route = "";
      let city = "";
      let state = "";
      let zipcode = "";

      const formattedAddress = place.formatted_address;

      const rawInput =
        document.getElementById("googleAutocompleteProListing")?.value ?? "";
      const manualUnitInput = propertyData.streetAddress2 ?? "";

      let unit = "";

      const unitSource = manualUnitInput || rawInput || formattedAddress;

      // Updated regex (no \b before #)
      const unitMatch = unitSource.match(
        /(?:Apt|Unit|Suite|#)\s*([A-Za-z0-9\-]+)/i
      );

      if (unitMatch) {
        const fullMatch = unitMatch[0]
          .toUpperCase()
          .replace(/\s+/g, " ")
          .trim(); // Normalize label+number
        unit = fullMatch.replace(/APT|SUITE|UNIT/, "UNIT"); // Normalize label if needed
      }

      if (Array.isArray(place.address_components)) {
        for (const component of place.address_components) {
          const componentType = component.types[0];

          switch (componentType) {
            case "street_number":
              streetNumber = component.long_name || "";
              break;
            case "route":
              route = component.long_name || "";
              break;
            case "locality":
              city = component.long_name || "";
              break;
            case "administrative_area_level_1":
              state = component.short_name || "";
              break;
            case "postal_code":
              zipcode = component.long_name || "";
              break;
          }
        }
      }

      let unit_normalized = normalizeUnit(unit);

      let streetAddress1 = `${streetNumber} ${route}`.trim();

      let address_signatures = generateAddressSignature(
        streetAddress1,
        city,
        state,
        zipcode
      );
      // Update form state
      setPropertyData((prev) => ({
        ...prev,
        streetAddress1: streetAddress1,
        streetAddress2: unit,
        city,
        state,
        zipcode,
        unit_normalized: unit_normalized,
        address_signatures: address_signatures,
      }));
    } catch (error) {
      console.error("Error in handlePlaceSelect:", error);
      showErrorMessage("There was an error processing the address");
    }
  }, []);

  // Separate effect for Google Places initialization to make it more robust
  useEffect(() => {
    let timeoutId;
    let autocompleteInstance = null;

    // Initialize Places autocomplete
    const initPlacesAutocomplete = () => {
      // Check if the Google Maps script has loaded
      if (
        !isLoaded ||
        !window.google ||
        !window.google.maps ||
        !window.google.maps.places
      ) {
        // If not loaded yet, try again in 500ms
        timeoutId = setTimeout(initPlacesAutocomplete, 500);
        return;
      }

      try {
        const autocompleteInput = document.getElementById(
          "googleAutocompleteProListing"
        );
        if (!autocompleteInput) {
          console.log("Autocomplete input not found, retrying...");
          timeoutId = setTimeout(initPlacesAutocomplete, 500);
          return;
        }

        // Create the autocomplete instance
        autocompleteInstance = new window.google.maps.places.Autocomplete(
          autocompleteInput,
          {
            types: ["address"],
            componentRestrictions: { country: "us" },
            fields: ["address_components", "geometry", "formatted_address"],
          }
        );

        // Add the place_changed event listener
        autocompleteInstance.addListener("place_changed", () => {
          // setAutocompleteRef(autocompleteInstance);
          // handlePlaceSelect();

          const place = autocompleteInstance.getPlace();
          handlePlaceSelect(place);
        });

        console.log("Google Places Autocomplete initialized successfully");
      } catch (error) {
        console.error("Error initializing Places Autocomplete:", error);
      }
    };

    // Start the initialization process after a delay
    if (isLoaded && !loadError) {
      timeoutId = setTimeout(initPlacesAutocomplete, 1000);
    }

    // Cleanup function
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (autocompleteInstance) {
        try {
          window.google?.maps?.event?.clearInstanceListeners(
            autocompleteInstance
          );
        } catch (error) {
          console.error("Error cleaning up event listeners:", error);
        }
      }
    };
  }, [isLoaded, loadError, handlePlaceSelect]);

  const eighteenYearsAgo = dayjs().subtract(18, "year");

  const handleUserDataChange = (event) => {
    const { name, value, type, files } = event.target;
    setUserData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));

    setPageState((prev) => ({
      ...prev,
      ownerDetails: false,
    }));
  };

  const handleListingDataChange = (event) => {
    const { name, value } = event.target;
    setListingData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setPageState((prev) => ({
      ...prev,
      listingDetails: false,
    }));
  };

  const selectListingType = (listingType) => {
    setListingData((prev) => ({
      ...prev,
      listingType: listingType,
    }));
    setPageState((prev) => ({
      ...prev,
      listingDetails: false,
    }));
  };

  const updateAddressHide = (e) => {
    setListingData((prev) => ({
      ...prev,
      hideAddress: e.target.checked,
    }));
    setPageState((prev) => ({
      ...prev,
      listingDetails: false,
    }));
  };

  // const handleDateChange = (date, field) => {
  //   setListingData({
  //     ...listingData,
  //     [field]: date ? dayjs(date).format("YYYY-MM-DD") : "",
  //   });
  //   setPageState((prev) => ({
  //     ...prev,
  //     listingDetails: false,
  //   }));
  // };

  const handleDateChange = (value, label) => {
    setListingData((prev) => ({
      ...prev,
      [label]: value,
    }));
    setPageState((prev) => ({
      ...prev,
      listingDetails: false,
    }));
  };

  const onPropImagesChange = (imageList) => {
    setPropImages(imageList);
    setPageState((prev) => ({
      ...prev,
      propertyDetails: false,
    }));
  };

  const handleExpandClick = (section) => {
    setExpanded((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const showErrorMessage = (text) => {
    toast.error(text, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const resetForm = () => {
    setPropertyData({
      propertyType: "",
      bedrooms: "",
      bathrooms: "",
      areaSqft: "",
      streetAddress1: "",
      streetAddress2: "",
      landmark: "",
      city: "",
      state: "",
      zipcode: "",
      yearBuilt: "",
      images: null,
      heatingCooling: "",
    });
    setListingData({
      houseVisitsFrom: dayjs(),
      availableFrom: dayjs(),
      title: "",
      description: "",
      hideAddress: false,
      sellPrice: "",
      hoaPrice: "",
      rentPrice: "",
      listingType: null,
      sellHOAFreq: "",
      rentPetPolicy: "",
      rentLeaseLength: "",
    });
    setPropImages([]);
    setPageState({
      propertyDetails: false,
      listingDetails: false,
    });
    setShowThankYou(false);
    setCreatedListingUrl("");
    setCreatedListingType(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Property section check
    if (!pageState.propertyDetails) {
      // Validate property details
      if (!propertyData.propertyType) {
        showErrorMessage("Please select the property type");
        return;
      }
      if (!propertyData.yearBuilt) {
        showErrorMessage("Please provide year the property was built in");
        return;
      }
      if (propertyData.yearBuilt && parseInt(propertyData.yearBuilt) < 0) {
        showErrorMessage("Please enter a valid year");
        return;
      }
      if (!propertyData.bedrooms) {
        showErrorMessage("Please enter the number of bedrooms in the property");
        return;
      }
      if (propertyData.bedrooms && parseInt(propertyData.bedrooms) < 0) {
        showErrorMessage("Please enter a valid number of bedrooms");
        return;
      }
      if (!propertyData.bathrooms) {
        showErrorMessage(
          "Please enter the number of bathrooms in the property"
        );
        return;
      }
      if (propertyData.bathrooms && parseInt(propertyData.bathrooms) < 0) {
        showErrorMessage("Please enter a valid number of bathrooms");
        return;
      }
      if (!propertyData.areaSqft) {
        showErrorMessage("Please enter the size of the property in Sqft");
        return;
      }
      if (propertyData.areaSqft && parseInt(propertyData.areaSqft) < 0) {
        showErrorMessage("Please enter a valid area");
        return;
      }
      if (!propertyData.heatingCooling) {
        showErrorMessage("Please provide the heating and cooling policy");
        return;
      }
      if (!propertyData.streetAddress1) {
        showErrorMessage("Please enter the street address");
        return;
      }
      if (!propertyData.city) {
        showErrorMessage("Please provide the city");
        return;
      }
      if (!propertyData.state) {
        showErrorMessage("Please select the state");
        return;
      }
      if (!propertyData.zipcode) {
        showErrorMessage("Please provide the zipcode");
        return;
      }

      const result = await validateManualAddress({
        streetAddress1: propertyData.streetAddress1,
        city: propertyData.city,
        state: propertyData.state,
        zipcode: propertyData.zipcode,
      });

      if (!result.isValid) {
        showErrorMessage(
          `We couldn't validate the address. Did you mean: "${result.formattedAddress}"?`
        );
        return;
      }

      if (!propertyData.landmark) {
        showErrorMessage("Please provide any nearby landmark");
        return;
      }

      // Set property details to true if all validations pass
      setPageState((prev) => ({
        ...prev,
        propertyDetails: true,
      }));

      // Open the listing details section if not already open
      if (!expanded.listingDetails) {
        setExpanded((prev) => ({
          ...prev,
          listingDetails: true,
        }));
        return;
      }
    }

    // Listing section check
    if (!pageState.listingDetails) {
      if (!listingData.listingType) {
        showErrorMessage(
          "Please select whether you want to Rent or Sell the property"
        );
        return;
      }
      if (!listingData.availableFrom) {
        showErrorMessage(
          "Please provide the date from which the property will be available"
        );
        return;
      }
      if (!listingData.houseVisitsFrom) {
        showErrorMessage(
          "Please provide the date from which the property can be visited"
        );
        return;
      }
      if (listingData.listingType === listingStates.rent) {
        if (!listingData.rentPrice) {
          showErrorMessage("Please provide the monthly rent");
          return;
        }
        if (listingData.rentPrice && parseInt(listingData.rentPrice) < 0) {
          showErrorMessage("Please enter a valid rent price");
          return;
        }
        if (!listingData.rentLeaseLength) {
          showErrorMessage("Please provide the lease length in no.of months");
          return;
        }
        if (
          listingData.rentLeaseLength &&
          parseInt(listingData.rentLeaseLength) < 0
        ) {
          showErrorMessage("Please enter a valid lease length");
          return;
        }
        if (!listingData.rentPetPolicy) {
          showErrorMessage("Please provide the pet policy for your tenants");
          return;
        }

        listingData.isRentProperty = true;
      }
      if (listingData.listingType === listingStates.sell) {
        if (!listingData.sellPrice) {
          showErrorMessage("Please provide the selling price");
          return;
        }
        if (listingData.sellPrice && parseInt(listingData.sellPrice) < 0) {
          showErrorMessage("Please enter a valid sell price");
          return;
        }
        if (!listingData.sellHOAFreq) {
          showErrorMessage("Please select the monthly HOA Fee");
          return;
        }
        // if (listingData.sellHOAFee && parseInt(listingData.sellHOAFee) < 0) {
        //   showErrorMessage("Please enter a valid HOA fee");
        //   return;
        // }

        if (
          listingData.sellHOAFreq &&
          (!listingData.hoaPrice || parseInt(listingData.hoaPrice) < 0)
        ) {
          showErrorMessage("Please enter a valid hoa  price");
          return;
        }

        listingData.isSellProperty = true;
      }

      // Set listing details to true if all validations pass
      setPageState((prev) => ({
        ...prev,
        listingDetails: true,
      }));
    }

    // If all validations pass, proceed with submission
    showLoader();
    // console.log("selectedAgency.id", selectedAgency);
    try {
      const requestData = {
        propertyData: {
          ...propertyData,
        },
        listingData: {
          ...listingData,
          agencyId: selectedAgency,
          houseVisitsFrom: listingData.houseVisitsFrom.format("YYYY-MM-DD"),
          availableFrom: listingData.availableFrom.format("YYYY-MM-DD"),
        },
      };

      // console.log(
      //   "accessToken - as only available for registered professionals: ",
      //   accessToken
      // );
      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/professional/listing/create`,
        requestData,
        {
          headers: { Authorization: accessToken },
        }
      );
      // console.log(response.data.success)
      if (response.data && response.data.success) {
        // Upload images if available
        if (propImages && propImages.length > 0) {
          const isUploadSuccess = await uploadImages(
            response.data.propertyId,
            accessToken
          );

          if (!isUploadSuccess) {
            // Handle upload failure (e.g., notify admin or user)
            console.error("Failed to upload images");
            showErrorMessage("Failed to upload images!");
            // You might want to add some user notification here
          }

          // show thank you
          // if add naother property, reset data
          // if view all listings, take to the dashbaord
          // if view live listing, take to website - listing details page
        }
        setCreatedListingType(response.data.listingType);
        setCreatedListingUrl(response.data.listingUrl);
        // console.log('BEFORE', showThankYou);
        setShowThankYou(true);
        // console.log('AFTERE', showThankYou);
        setCreatedListingId(response.data.listingId);
        // toast.success("Listing created successfully!");
      } else {
        showErrorMessage(response.data.message || "Error creating listing");
        // console.log(response.data.message || "Error creating listing");
      }
    } catch (error) {
      if (error.response?.status === 409) {
        setDuplicateListingInfo({
          show: true,
          propertyId: error.response.data.existingPropertyId,
          message: error.response.data.message,
          listingData: error.response.data.existingListings || [],
        });
      } else {
        showErrorMessage("An error occurred while creating the listing");
      }
      console.error("Error creating listing:", error);
    } finally {
      hideLoader();
    }
  };

  const validateManualAddress = ({ streetAddress1, city, state, zipcode }) => {
    return new Promise((resolve, reject) => {
      const address = `${streetAddress1}, ${city}, ${state} ${zipcode}`;

      if (!window.google || !window.google.maps) {
        console.error("Google Maps JS SDK not loaded");
        return resolve({ isValid: false });
      }

      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results && results.length > 0) {
          const place = results[0];

          // Extract structured address components
          let correctedCity = "";
          let correctedState = "";
          let correctedZipcode = "";

          let formattedAddress = place.formatted_address;

          for (const component of place.address_components) {
            if (component.types.includes("locality")) {
              correctedCity = component.long_name;
            }
            if (component.types.includes("administrative_area_level_1")) {
              correctedState = component.short_name;
            }
            if (component.types.includes("postal_code")) {
              correctedZipcode = component.long_name;
            }
          }

          if (correctedCity != city) {
            return resolve({
              isValid: false,
              formatted: place.formatted_address,
              correctedCity,
              correctedState,
              correctedZipcode,
              formattedAddress,
            });
          }

          if (correctedState != state) {
            return resolve({
              isValid: false,
              formatted: place.formatted_address,
              correctedCity,
              correctedState,
              correctedZipcode,
              formattedAddress,
            });
          }

          if (correctedZipcode != zipcode) {
            return resolve({
              isValid: false,
              formatted: place.formatted_address,
              correctedCity,
              correctedState,
              correctedZipcode,
              formattedAddress,
            });
          }

          return resolve({
            isValid: true,
            formatted: place.formatted_address,
            correctedCity,
            correctedState,
            correctedZipcode,
          });
        } else {
          return resolve({ isValid: false });
        }
      });
    });
  };

  const uploadImages = async (propertyId, accessToken) => {
    try {
      // Create a FormData object for the API request
      const formData = new FormData();

      // Append images if any
      if (propImages) {
        propImages.forEach((image) => {
          if (image.file) {
            formData.append("images", image.file);
          }
        });
      }

      formData.append("propertyId", propertyId);

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/properties/upload-images`,
        formData,
        {
          headers: {
            Authorization: accessToken,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data && response.data.success) {
        // console.log("Images uploaded successfully");
        return true;
      } else {
        const errorMsg =
          response.data && response.data.message
            ? response.data.message
            : "Some error occurred while uploading images!";
        showErrorMessage(errorMsg);
        return false;
      }
    } catch (error) {
      console.error("Error during image upload:", error);
      showErrorMessage("Some error occurred while uploading images!");
      return false;
    }
  };

  const ThankYouMessage = () => (
    <>
      <Box
        sx={{
          textAlign: "center",
          padding: "2rem",
          border: "1px solid #4CAF50",
          borderRadius: "8px",
          backgroundColor: "#E8F5E9",
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "#4CAF50" }} />
        <Typography variant="h4" sx={{ color: "#4CAF50", marginTop: "1rem" }}>
          Listing created successfully!
        </Typography>
        <Box sx={{ marginTop: "2rem" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={resetForm}
            sx={{ margin: "0.5rem" }}
          >
            Add Another Property
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/MyFirstLand?category=prolistings")}
            sx={{ margin: "0.5rem" }}
          >
            View All Pro Listings
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              const specialString = getSpecialString(createdListingType);
              window.open(
                `${
                  import.meta.env.VITE_FRONTEND_URL
                }/${specialString}/${createdListingUrl}`,
                "_blank"
              );
            }}
            sx={{ margin: "0.5rem" }}
          >
            View Live Pro Listing
          </Button>
        </Box>
      </Box>
      <div className={styles.container}>
        {createdListingId ? (
          <div className={styles.messageBox}>
            <p className={styles.description}>
              Your property listing has been successfully created and is now
              visible to potential renters.
            </p>
            <div className={styles.premiumSection}>
              <h3 className={styles.premiumTitle}>Upgrade to Premium</h3>
              <p className={styles.premiumText}>
                Do you want to take the Premium Service for your listing?
              </p>
              <div className={styles.benefitsList}>
                <h4>Benefits Included:</h4>
                <ul>
                  <li>Feature at the top of search results</li>
                  <li>Highlighted listing with a premium badge</li>
                  <li>Promoted on the homepage banner</li>
                  <li>Advanced analytics and performance insights</li>
                </ul>
              </div>
              <button className={styles.upgradeButton} onClick={handleUpgrade}>
                Upgrade to Premium
              </button>
            </div>
          </div>
        ) : (
          <div className={styles.unauthorizedMessage}>Unauthorized access</div>
        )}
      </div>
    </>
  );

  return (
    <div className="primary-wrapper">
      <Dialog
        open={duplicateListingInfo?.show}
        onClose={() => setDuplicateListingInfo(null)}
      >
        <DialogTitle>Listing Already Exists</DialogTitle>
        <DialogContent>
          <p>{duplicateListingInfo?.message}</p>
          <p>Would you like to view the existing listing?</p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setDuplicateListingInfo(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              const specialString = getSpecialString(
                parseInt(duplicateListingInfo.listingData?.listing_type),
                10
              );
              const listingUrl = duplicateListingInfo.listingData?.url;

              if (specialString && listingUrl) {
                window.open(
                  `${
                    import.meta.env.VITE_FRONTEND_URL
                  }/${specialString}/${listingUrl}`,
                  "_blank"
                );
              } else {
                toast.error("Listing information is incomplete.");
              }
            }}
          >
            View Listing
          </Button>
        </DialogActions>
      </Dialog>
      <Navbar />
      <div className="primary-container">
        <div className={styles.title}>
          <h1>Add New Listing</h1>
        </div>
        {showThankYou ? (
          <ThankYouMessage />
        ) : (
          <div className={styles.pageContent}>
            <div className={styles.section}>
              <div
                className={styles.sectionHeader}
                onClick={() => handleExpandClick("ownerDetails")}
              >
                <div className={styles.sectionNumber}>1</div>
                <div className={styles.sectionTitle}>Owner Details</div>
                <div
                  className={styles.sectionDropdownBtn}
                  style={dropDownIconStyleOwnerDetails}
                >
                  <ExpandMoreIcon fontSize="large" />
                </div>
              </div>
              <Collapse in={expanded.ownerDetails} timeout="auto" unmountOnExit>
                <div className={styles.formSection}>
                  <div className={styles.formComponent}>
                    <TextField
                      id="firstName"
                      name="firstName"
                      label="First Name"
                      variant="outlined"
                      required
                      type="text"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.firstName ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="middleName"
                      name="middleName"
                      label="Middle Name"
                      variant="outlined"
                      type="text"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.middleName ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="lastName"
                      name="lastName"
                      label="Last Name"
                      variant="outlined"
                      required
                      type="text"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.lastName ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType2}`}
                  >
                    <TextField
                      id="email"
                      name="email"
                      label="Email"
                      variant="outlined"
                      required
                      type="email"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.email ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType2}`}
                  >
                    <TextField
                      id="phoneNumber"
                      name="phoneNumber"
                      label="Phone Number"
                      variant="outlined"
                      type="number"
                      inputProps={{ maxLength: 10 }}
                      fullWidth
                      disabled={isOldUser}
                      value={userData.phoneNumber ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  {!isOldUser && (
                    <div
                      className={`${styles.formComponent} ${styles.componentType1}`}
                    >
                      <TextField
                        id="password"
                        name="password"
                        label="Password"
                        variant="outlined"
                        required
                        type="password"
                        fullWidth
                        value={userData.password ?? ""}
                        onChange={handleUserDataChange}
                      />
                      <TextField
                        id="confirmPassword"
                        name="confirmPassword"
                        label="Confirm Password"
                        variant="outlined"
                        required
                        type="password"
                        fullWidth
                        value={userData.confirmPassword ?? ""}
                        onChange={handleUserDataChange}
                      />
                    </div>
                  )}
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <TextField
                      id="screenName"
                      name="screenName"
                      label="Screen Name"
                      variant="outlined"
                      type="text"
                      fullWidth
                      disabled={isOldUser}
                      value={userData.screenName ?? ""}
                      onChange={handleUserDataChange}
                    />
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <FormControl fullWidth>
                      <LocalizationProvider
                        key={"DOB"}
                        dateAdapter={AdapterDayjs}
                      >
                        <DatePicker
                          id="dateOfBirth"
                          name="dateOfBirth"
                          label="DOB"
                          value={userData.dateOfBirth ?? ""}
                          disableFuture
                          disabled={isOldUser}
                          maxDate={eighteenYearsAgo}
                          onChange={(value) =>
                            handleDateChange(value, "user", "dateOfBirth")
                          }
                          // renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </div>
                  <div
                    className={`${styles.formComponent} ${styles.componentType3}`}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="gender-label">Gender</InputLabel>
                      <Select
                        labelId="gender-label"
                        id="gender"
                        name="gender"
                        label="Gender"
                        disabled={isOldUser}
                        value={userData.gender ?? ""}
                        onChange={handleUserDataChange}
                      >
                        <MenuItem value={"Male"}>Male</MenuItem>
                        <MenuItem value={"Female"}>Female</MenuItem>
                        <MenuItem value={"Other"}>Other</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {/* <div className="form-component">
                    <TextField
                      id="bio"
                      name="bio"
                      label="Bio"
                      multiline
                      rows={4}
                      value={userData.bio}
                      onChange={handleUserDataChange}
                    />
                  </div> */}
                  {isOldUser && (
                    <div className={styles.formComponent}>
                      <div>
                        If you need to update your personal details, please go
                        to the User Profile page by clicking here:{" "}
                        <Link to="/User">User Profile</Link>
                      </div>
                    </div>
                  )}
                </div>
              </Collapse>
            </div>
            <div className={styles.section}>
              <div
                className={styles.sectionHeader}
                onClick={() => handleExpandClick("propertyDetails")}
              >
                <div className={styles.sectionNumber}>2</div>
                <div className={styles.sectionTitle}>Property Details</div>
                <div
                  className={styles.sectionDropdownBtn}
                  style={dropDownIconStylePropertyDetails}
                >
                  <ExpandMoreIcon fontSize="large" />
                </div>
              </div>
              <Collapse
                in={expanded.propertyDetails}
                timeout="auto"
                unmountOnExit
              >
                <div className={styles.formSection}>
                  <div className={styles.formComponent}>
                    <FormControl fullWidth>
                      <InputLabel id="property-type-label">
                        Property Type *
                      </InputLabel>
                      <Select
                        labelId="property-type-label"
                        id="propertyType"
                        name="propertyType"
                        label="Property Type"
                        value={propertyData.propertyType ?? ""}
                        onChange={handlePropertyDataChange}
                      >
                        {propertyTypes &&
                          Object.values(propertyTypes).map((type) => (
                            <MenuItem key={type.id} value={type.id}>
                              {type.label}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={styles.formComponentGroup}>
                    <TextField
                      id="yearBuilt"
                      name="yearBuilt"
                      label="Year Built"
                      variant="outlined"
                      required
                      type="number"
                      fullWidth
                      value={propertyData.yearBuilt ?? ""}
                      onChange={handlePropertyDataChange}
                      inputProps={{ min: 1800 }}
                    />
                    <TextField
                      id="bedrooms"
                      name="bedrooms"
                      label="Bedrooms"
                      variant="outlined"
                      required
                      type="number"
                      fullWidth
                      value={propertyData.bedrooms ?? ""}
                      onChange={handlePropertyDataChange}
                      inputProps={{ min: 0 }}
                    />
                    <TextField
                      id="bathrooms"
                      name="bathrooms"
                      label="Bathrooms"
                      variant="outlined"
                      required
                      type="number"
                      fullWidth
                      value={propertyData.bathrooms ?? ""}
                      onChange={handlePropertyDataChange}
                      inputProps={{ min: 1 }}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="areaSqft"
                      name="areaSqft"
                      label="Area (in Sqft)"
                      variant="outlined"
                      required
                      type="number"
                      fullWidth
                      value={propertyData.areaSqft ?? ""}
                      onChange={handlePropertyDataChange}
                      inputProps={{ min: 1 }}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <TextField
                      id="heatingCooling"
                      name="heatingCooling"
                      label="Heating & Cooling"
                      variant="outlined"
                      required
                      type="text"
                      multiline
                      rows={4}
                      fullWidth
                      value={propertyData.heatingCooling ?? ""}
                      onChange={handlePropertyDataChange}
                    />
                  </div>

                  <div className={styles.formComponent}>
                    {isLoaded ? (
                      <>
                        <div className={styles.googleAddressContainer}>
                          <label
                            htmlFor="googleAutocomplete"
                            className={styles.addressLabel}
                          >
                            Search for your address *
                          </label>
                          <input
                            id="googleAutocompleteProListing"
                            className={styles.googleAutocomplete}
                            placeholder="Type your address and select from dropdown"
                            type="text"
                          />
                          {loadError && (
                            <div className={styles.addressError}>
                              Error loading Google Maps API. Please check your
                              connection.
                            </div>
                          )}
                          <small className={styles.addressHelperText}>
                            Please select an address from the dropdown to
                            autocomplete city, state and zip code
                          </small>
                        </div>
                        <TextField
                          id="streetAddress1"
                          name="streetAddress1"
                          label="Street Address"
                          variant="outlined"
                          required
                          type="text"
                          fullWidth
                          value={propertyData.streetAddress1 ?? ""}
                          disabled={!propertyData.streetAddress1}
                          sx={{ marginTop: "10px" }}
                        />
                      </>
                    ) : (
                      <TextField
                        id="streetAddress1"
                        name="streetAddress1"
                        label="Street Address 1"
                        variant="outlined"
                        required
                        type="text"
                        fullWidth
                        value={propertyData.streetAddress1 ?? ""}
                        onChange={handlePropertyDataChange}
                      />
                    )}
                    {/* <TextField
                        id="streetAddress1"
                        name="streetAddress1"
                        label="Street Address 1"
                        variant="outlined"
                        required
                        type="text"
                        fullWidth
                        value={propertyData.streetAddress1}
                        onChange={handlePropertyDataChange}
                      /> */}
                  </div>
                  <div className={styles.formComponentGroup}>
                    <TextField
                      id="streetAddress2"
                      name="streetAddress2"
                      label="Apt / Unit / Suite (optional)"
                      variant="outlined"
                      type="text"
                      fullWidth
                      value={propertyData.streetAddress2 ?? ""}
                      onChange={handlePropertyDataChange}
                    />
                    <TextField
                      id="city"
                      name="city"
                      label="City"
                      variant="outlined"
                      required
                      type="text"
                      fullWidth
                      value={propertyData.city ?? ""}
                      onChange={handlePropertyDataChange}
                    />
                  </div>
                  <div className={styles.formComponentGroup}>
                    <FormControl fullWidth>
                      <InputLabel id="state-label">State *</InputLabel>
                      <Select
                        labelId="state-label"
                        id="state"
                        name="state"
                        label="State"
                        value={propertyData.state ?? ""}
                        onChange={handlePropertyDataChange}
                      >
                        {stateOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      id="zipcode"
                      name="zipcode"
                      label="Zipcode"
                      variant="outlined"
                      required
                      type="text"
                      fullWidth
                      value={propertyData.zipcode ?? ""}
                      onChange={handlePropertyDataChange}
                    />
                    <TextField
                      id="landmark"
                      name="landmark"
                      label="Landmark Nearby"
                      variant="outlined"
                      required
                      type="text"
                      fullWidth
                      value={propertyData.landmark ?? ""}
                      onChange={handlePropertyDataChange}
                    />
                  </div>
                  <div className={styles.formComponent}>
                    <ImageUploading
                      multiple
                      value={propImages ?? ""}
                      onChange={onPropImagesChange}
                      maxNumber={maxNumber}
                      dataURLKey="data_url"
                    >
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                      }) => (
                        <div className={styles.uploadImageWrapper}>
                          <div
                            className={styles.uploadImageBox}
                            {...dragProps}
                            onClick={onImageUpload}
                          >
                            {isDragging ? (
                              <p>Drop the images here ...</p>
                            ) : (
                              <>
                                <CloudUploadIcon sx={{ fontSize: 48 }} />
                                <p>
                                  Drag & Drop images here or Click to browse
                                </p>
                              </>
                            )}
                          </div>
                          {imageList.length > 0 && (
                            <div className={styles.imageList}>
                              {imageList.map((image, index) => (
                                <div key={index} className={styles.imageItem}>
                                  <img
                                    src={image["data_url"]}
                                    alt={`uploaded-${index}`}
                                    width="100"
                                  />
                                  <div className={styles.imageItemBtnWrapper}>
                                    <Button
                                      onClick={() => onImageUpdate(index)}
                                    >
                                      Update
                                    </Button>
                                    <Button
                                      onClick={() => onImageRemove(index)}
                                    >
                                      Remove
                                    </Button>
                                  </div>
                                </div>
                              ))}
                              <Button onClick={onImageRemoveAll}>
                                Remove all images
                              </Button>
                            </div>
                          )}
                        </div>
                      )}
                    </ImageUploading>
                  </div>
                </div>
              </Collapse>
            </div>

            <div className={styles.section}>
              <div
                className={styles.sectionHeader}
                onClick={() => handleExpandClick("listingDetails")}
              >
                <div className={styles.sectionNumber}>3</div>
                <div className={styles.sectionTitle}>Listing Details</div>
                <div
                  className={styles.sectionDropdownBtn}
                  style={dropDownIconStyleListingDetails}
                >
                  <ExpandMoreIcon fontSize="large" />
                </div>
              </div>
              <Collapse
                in={expanded.listingDetails}
                timeout="auto"
                unmountOnExit
              >
                <div className={styles.formSection}>
                  <div className={styles.rentSellSelection}>
                    <Typography
                      variant="h6"
                      className={styles.rentSellSelectionQuestion}
                    >
                      Is this property for Rent or Sale?
                    </Typography>
                    <div className={styles.rentSellSelectionContainer}>
                      <div className={styles.rentSellSelectionBox}>
                        <Button
                          className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionLeft}`}
                          variant={
                            listingData.listingType === listingStates.rent
                              ? "contained"
                              : "outlined"
                          }
                          onClick={() => selectListingType(listingStates.rent)}
                        >
                          Rent
                        </Button>
                        <Button
                          className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionRight}`}
                          variant={
                            listingData.listingType === listingStates.sell
                              ? "contained"
                              : "outlined"
                          }
                          onClick={() => selectListingType(listingStates.sell)}
                        >
                          Sell
                        </Button>
                      </div>
                    </div>
                  </div>

                  {listingData.listingType && (
                    <>
                      <div className={styles.formComponentGroup}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Available From"
                            value={listingData.availableFrom ?? ""}
                            onChange={(newValue) =>
                              handleDateChange(newValue, "availableFrom")
                            }
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                          />
                        </LocalizationProvider>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="House Visits From"
                            value={listingData.houseVisitsFrom ?? ""}
                            onChange={(newValue) =>
                              handleDateChange(newValue, "houseVisitsFrom")
                            }
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                          />
                        </LocalizationProvider>
                      </div>

                      {listingData.listingType === listingStates.rent && (
                        <>
                          <div className={styles.formComponentGroup}>
                            <TextField
                              id="rentPrice"
                              name="rentPrice"
                              label="Rent (per month)"
                              variant="outlined"
                              required
                              type="number"
                              fullWidth
                              value={listingData.rentPrice ?? ""}
                              onChange={handleListingDataChange}
                              inputProps={{ min: 1 }}
                            />
                            <TextField
                              id="rentLeaseLength"
                              name="rentLeaseLength"
                              label="Lease Length (in months)"
                              variant="outlined"
                              required
                              type="number"
                              fullWidth
                              value={listingData.rentLeaseLength ?? ""}
                              onChange={handleListingDataChange}
                              inputProps={{ min: 1 }}
                            />
                          </div>
                          <div className={styles.formComponent}>
                            <TextField
                              id="rentPetPolicy"
                              name="rentPetPolicy"
                              label="Pet Policy"
                              variant="outlined"
                              required
                              type="text"
                              multiline
                              rows={4}
                              fullWidth
                              value={listingData.rentPetPolicy ?? ""}
                              onChange={handleListingDataChange}
                            />
                          </div>
                        </>
                      )}

                      {listingData.listingType === listingStates.sell && (
                        <div className={styles.formComponentGroup}>
                          <TextField
                            id="sellPrice"
                            name="sellPrice"
                            label="Selling Price"
                            variant="outlined"
                            required
                            type="number"
                            fullWidth
                            value={listingData.sellPrice ?? ""}
                            onChange={handleListingDataChange}
                            inputProps={{ min: 1 }}
                          />
                          <FormControl fullWidth variant="outlined" required>
                            <InputLabel id="sellHOAFee-label">
                              HOA Fee
                            </InputLabel>
                            <Select
                              labelId="sellHOAFee-label"
                              id="sellHOAFreq"
                              name="sellHOAFreq"
                              value={listingData.sellHOAFreq ?? ""}
                              onChange={handleListingDataChange}
                              label="HOA Fee"
                            >
                              <MenuItem value="monthly">Monthly</MenuItem>
                              <MenuItem value="quarterly">Quarterly</MenuItem>
                              <MenuItem value="semi-annually">
                                Semi-Annually
                              </MenuItem>
                              <MenuItem value="annually">Annually</MenuItem>
                              <MenuItem value="none">None</MenuItem>
                            </Select>
                          </FormControl>

                          <TextField
                            id="hoaPrice"
                            name="hoaPrice"
                            label="HOA Price"
                            variant="outlined"
                            required
                            type="number"
                            fullWidth
                            value={listingData.hoaPrice ?? ""}
                            onChange={handleListingDataChange}
                            inputProps={{ min: 1 }}
                          />
                        </div>
                      )}

                      <div className={styles.formComponent}>
                        <TextField
                          id="title"
                          name="title"
                          label="Listing Title"
                          variant="outlined"
                          // required
                          type="text"
                          fullWidth
                          value={listingData.title ?? ""}
                          onChange={handleListingDataChange}
                        />
                      </div>
                      <div className={styles.formComponent}>
                        <TextField
                          id="description"
                          name="description"
                          label="Listing Description"
                          variant="outlined"
                          // required
                          type="text"
                          multiline
                          rows={4}
                          fullWidth
                          value={listingData.description ?? ""}
                          onChange={handleListingDataChange}
                        />
                      </div>
                      <div className={styles.formComponent}>
                        <TextField
                          id="agency-select"
                          select
                          label="Select Agency or As a freelancer"
                          value={selectedAgency ?? ""}
                          onChange={(e) => {
                            // console.log(e.target.value);
                            setSelectedAgency(e.target.value);
                          }}
                          variant="outlined"
                          fullWidth
                        >
                          {/* Option for "Personal" */}
                          <MenuItem value="-1">Freelancer</MenuItem>

                          {/* Dynamically render agency options */}
                          {agencies.map((agency) => (
                            <MenuItem key={agency.id} value={agency.id}>
                              {agency.agency_name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      {/* <div className={styles.formComponent}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={listingData.hideAddress}
                              onChange={updateAddressHide}
                            />
                          }
                          label="Hide street address and show only the approximate location"
                        />
                      </div> */}
                    </>
                  )}
                </div>
              </Collapse>
            </div>

            <div className={styles.formComponent}>
              <div className={styles.formAction}>
                <Button variant="contained" size="large" onClick={handleSubmit}>
                  Create Listing
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default ProAddListing;
